import user from '@/model/user';
import auth from '@/model/auth';
import error from '@/model/error';
import popup from '@/model/popup';
import store from '@/store';
import Vue from 'vue';
import VueRouter from 'vue-router';
import NotFound from '../pages/NotFound.vue';
import MainRoutes from './modules/main';
import PersonalRoutes from './modules/personal';
import AdminRoutes from './modules/admin';
import AuthRoutes from './modules/auth';
import ProjectRoutes from './modules/project';
import CompanyRoutes from './modules/company';
import NewsRoutes from './modules/news';
import AffiliateRoutes from './modules/affiliate';
import ExchangeRoutes from './modules/exchange';

Vue.use(VueRouter);

const routes = [
  ...MainRoutes,
  ...AdminRoutes,
  ...AuthRoutes,
  ...PersonalRoutes,
  ...ProjectRoutes,
  ...CompanyRoutes,
  ...NewsRoutes,
  ...AffiliateRoutes,
  ...ExchangeRoutes,
  { path: '*', component: NotFound },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ?? { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (store.state.closePrevent.enabled) {
    next(false);
    const question = 'У вас есть не сохраненные данные. Вы действительно хотите покинуть страницу?';
    const answer = await popup.addConfirm(question);
    if (!answer) {
      return;
    }
    store.commit('closePrevent/disable');
  }

  document.body.style.overflow = 'auto';
  error.clear();

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.meta.needAuth === false || store.state.auth.user) {
    next();
    return;
  }

  user.fetchSelf()
    .then(() => { next(); })
    .catch(() => {
      auth.goToRouteAfterLogin(to.fullPath);
      next({ name: 'auth-login' });
    });
});

export default router;
